import React, { useEffect, useState } from "react";

const ZONES = [
  { city: "Beijing", city_zh: "北京", tz: "Asia/Shanghai" },
  { city: "New York", city_zh: "纽约", tz: "America/New_York" },
  { city: "Vienna", city_zh: "维也纳", tz: "Europe/Vienna" },
  { city: "Tokyo", city_zh: "东京", tz: "Asia/Tokyo" },
];

function fmt(d, tz) {
  try {
    return new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false }).format(d);
  } catch (e) { return "--:--"; }
}

export default function WorldClock({ lang = "en" }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30 * 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div data-testid="world-clock" className="hidden md:flex items-center gap-4 text-[10px] tracking-[0.2em] uppercase text-[hsl(var(--muted-foreground))]">
      {ZONES.map((z) => (
        <div key={z.tz} data-testid={`world-clock-${z.tz.replace(/[/]/g, "-")}`} className="flex flex-col items-center leading-tight">
          <span className="text-[hsl(var(--foreground))]/80">{lang === "zh" ? z.city_zh : z.city}</span>
          <span className="font-mono text-[12px] tracking-normal text-[hsl(var(--foreground))]">{fmt(now, z.tz)}</span>
        </div>
      ))}
    </div>
  );
}
